import useMediaQuery from "@mui/material/useMediaQuery";
import { useIsClient } from "@uidotdev/usehooks";
import "react-toastify/dist/ReactToastify.css";
import JobSearchOptions from "../JobSearchOptions/JobSearchOptions";
import {
  FypIcon,
  SearchIcon,
  TabNav,
  TabNavContainer,
  TabNavWrapper,
} from "./styles";

export default function JobListNavigation(props) {
  const {
    selectedTab,
    handleTabNavClick,
    jobSearchRef = null,
    filterAnchorRef = null,
  } = props;
  const isClient = useIsClient();
  const isDesktop = useMediaQuery("(min-width: 1280px)");
  const isMobile = useMediaQuery("(max-width: 640px)");

  return isClient ? (
    <TabNavWrapper>
      <TabNavContainer>
        <TabNav
          onClick={() => handleTabNavClick("job-list")}
          $selected={selectedTab === "job-list"}
        >
          <JobSearchOptions
            ref={jobSearchRef}
            externalFilterAnchorRef={filterAnchorRef}
            handleJobsForYouClick={() => handleTabNavClick("for-you")}
            currentTab={selectedTab}
          />
        </TabNav>
        {/* {isMobile ? (
        <TabNav
          onClick={() => handleTabNavClick("for-you")}
          $selected={selectedTab === "for-you"}
        >
          <FypIcon />
          <span>Jobs for you</span>
        </TabNav> 
        ) : null} */}

      </TabNavContainer>
    </TabNavWrapper>
  ) : (
    <TabNavWrapper></TabNavWrapper>
  );
}
